export function useTouchDetector(di: TouchDetectorDependencies = {}): boolean {
  const {wndw = window, dcmt = document} = di;

  return (
    'ontouchstart' in wndw ||
    ((wndw as WindowWithTouch).DocumentTouch &&
      dcmt instanceof (wndw as WindowWithTouch).DocumentTouch) ||
    (wndw as WindowWithTouch).navigator.maxTouchPoints > 0
  );
}
